module.exports = __webpack_public_path__ + "components/zebra-list/static/clock-c51d9975a8c6e8342c0b96d302ec2af1.svg";